module.exports = __webpack_public_path__ + "static/media/Twitter-Icon.c87263d6.svg";